"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentChoiceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var journey_model_1 = require("@athena-portal/journey-model");
var PaymentChoiceWidget = exports.PaymentChoiceWidget = /** @class */ (function (_super) {
    __extends(PaymentChoiceWidget, _super);
    function PaymentChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "debit") {
                _this.setState({ nextPageIdCaseMonthlyDebit: _this.getSetting("nextPageIdCaseMonthlyDebit"), nextPageIdCaseMonthlyCard: undefined });
            }
            else if (event.target.value === "card") {
                _this.setState({ nextPageIdCaseMonthlyCard: _this.getSetting("nextPageIdCaseMonthlyCard"), nextPageIdCaseMonthlyDebit: undefined });
            }
        };
        _this.navigateNext = function () {
            if (_this.state.nextPageIdCaseMonthlyDebit) {
                _this.props.engine.navigate(_this.state.nextPageIdCaseMonthlyDebit);
            }
            else if (_this.state.nextPageIdCaseMonthlyCard) {
                _this.props.engine.navigate(_this.state.nextPageIdCaseMonthlyCard);
            }
        };
        _this.navigateBack = function () {
            if (_this.getSetting("previousPageId")) {
                _this.props.engine.navigate(_this.getSetting("previousPageId"));
            }
        };
        _this.state = {
            nextPageIdCaseMonthlyDebit: undefined,
            nextPageIdCaseMonthlyCard: _this.getSetting("nextPageIdCaseMonthlyCard")
        };
        return _this;
    }
    PaymentChoiceWidget.prototype.render = function () {
        var disabledClass = this.state.nextPageIdCaseMonthlyDebit || this.state.nextPageIdCaseMonthlyCard ? "" : "btn-disabled";
        return (React.createElement("div", { className: "w-100" },
            React.createElement("div", { className: "payment-choice d-flex" },
                React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pr-2" },
                    React.createElement("input", { id: "yearly", className: "custom-control-input", type: "radio", name: "payment", value: "card", defaultChecked: true, onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "yearly" },
                        this.state.nextPageIdCaseMonthlyCard ?
                            React.createElement("img", { className: "radio-circle", alt: "yearly selected", src: "/img/radio-circle-selected.svg" }) :
                            React.createElement("img", { className: "radio-circle", alt: "yearly", src: "/img/radio-circle.svg" }),
                        React.createElement("p", { className: "font-weight-semi-bold pt-3" }, "Monthly card payment"),
                        React.createElement("div", null,
                            React.createElement("img", { className: "visa-icon-small", alt: "visa-icon", src: "/img/visa-icon.svg" }),
                            React.createElement("img", { className: "mastercard-icon-small", alt: "mastercard-icon", src: "/img/mastercard-icon.svg" })),
                        React.createElement("p", { className: "font-weight-extra-light" }, "Automatic monthly payments from a Credit / Debit card"))),
                React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pl-2" },
                    React.createElement("input", { id: "monthly", className: "custom-control-input", type: "radio", name: "payment", value: "debit", onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "monthly" },
                        this.state.nextPageIdCaseMonthlyDebit ?
                            React.createElement("img", { className: "radio-circle", alt: "monthly selected", src: "/img/radio-circle-selected.svg" }) :
                            React.createElement("img", { className: "radio-circle", alt: "monthly", src: "/img/radio-circle.svg" }),
                        React.createElement("p", { className: "font-weight-semi-bold pt-3" }, "Monthly Direct Debit"),
                        React.createElement("img", { className: "direct-debit-icon-small", src: "/img/directDebitLogo.png", alt: "direct debit" }),
                        React.createElement("p", { className: "font-weight-extra-light" }, "You need a UK Bank / Building Society account to set up a Direct Debit")))),
            React.createElement("button", { className: "mb-0 btn btn-primary btn-next ".concat(disabledClass), id: "".concat(this.props.question.name), onClick: this.navigateNext }, "Next"),
            this.getSetting("previousPageId") && React.createElement("button", { className: "btn btn-back", onClick: this.navigateBack }, "Back")));
    };
    PaymentChoiceWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "previousPageId", type: journey_model_1.TypeDescriptions.String },
            { name: "nextPageIdCaseMonthlyDebit", type: journey_model_1.TypeDescriptions.String },
            { name: "nextPageIdCaseMonthlyCard", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], PaymentChoiceWidget);
    return PaymentChoiceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=PaymentChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/payments/PaymentChoiceWidget.js
// module id = 3453
// module chunks = 0